import { render, staticRenderFns } from "./MADDView.vue?vue&type=template&id=34cf438e&scoped=true"
import script from "./MADDView.vue?vue&type=script&lang=js"
export * from "./MADDView.vue?vue&type=script&lang=js"
import style0 from "./MADDView.vue?vue&type=style&index=0&id=34cf438e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34cf438e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/MAIS/MAIS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('34cf438e')) {
      api.createRecord('34cf438e', component.options)
    } else {
      api.reload('34cf438e', component.options)
    }
    module.hot.accept("./MADDView.vue?vue&type=template&id=34cf438e&scoped=true", function () {
      api.rerender('34cf438e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/MADD/MADDView.vue"
export default component.exports